const name = "@prismicio/adapter-nuxt";
export {
  name
};
//# sourceMappingURL=package.json.js.map
